<template>
  <div class="app-container">
    <BjRouteTabs :route-list="BUSINESS_ORDER_TIMELINESS" />
    <div class="width-full flex-spacebetween" style="padding:10px 40px">
      <BjDateTimerangePicker v-model="lineChart.queryParamsTime_pay" :default-time="Date.now() - 30 * 24 * 3600 * 1000" />
      <el-radio-group v-model="lineChart.tabData">
        <el-radio-button label="0">day</el-radio-button>
        <el-radio-button label="1">week</el-radio-button>
        <el-radio-button label="2">month</el-radio-button>
      </el-radio-group>
    </div>
    <LineChart :chart-data="lineChart.lineChartData" />
  </div>
</template>
<script>
import { BUSINESS_ORDER_TIMELINESS } from '@/utils/constants';
import LineChart from './LineChart';
import { afterApi } from '@/api';
import moment from 'moment';
const echarts = require('echarts/lib/echarts');
export default {
  name: 'BusinessOrderTimelinessAverage',
  components: { LineChart },
  data() {
    return {
      BUSINESS_ORDER_TIMELINESS,
      lineChart: {
        tabData: '0',
        lineChartData: {
          title: {
            text: 'ERP, SAP, and WMS System Average Order Processing Time Statistics Table',
            textStyle: {
              align: 'center',
              color: '#082dc3',
              fontSize: 20,
            },
            top: '7%',
            left: '40',
          },
          series: [
            // {
            //   name: 'Order Count(thousand)',
            //   type: 'line',
            //   smooth: false,
            //   showAllSymbol: true,
            //   symbol: 'circle',
            //   symbolSize: 15,
            //   lineStyle: {
            //     normal: {
            //       shadowColor: 'rgba(0, 0, 0, .3)',
            //       shadowBlur: 0,
            //       shadowOffsetY: 5,
            //       shadowOffsetX: 5,
            //     },
            //   },
            //   label: {
            //     show: true,
            //     position: 'top',
            //     textStyle: {
            //       color: '#082dc3',
            //     }
            //   },
            //   itemStyle: {
            //     color: '#082dc3',
            //     borderColor: '#fff',
            //     borderWidth: 2,
            //     shadowColor: 'rgba(0, 0, 0, .3)',
            //     shadowBlur: 0,
            //     shadowOffsetY: 2,
            //     shadowOffsetX: 2,
            //   },
            //   areaStyle: {
            //       normal: {
            //           color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            //                   offset: 0,
            //                   color: 'rgba(255,115,16,0.3)'
            //               },
            //               {
            //                   offset: 1,
            //                   color: 'rgba(255,115,16,0)'
            //               }
            //           ], false),
            //           shadowColor: 'rgba(255,115,16, 0.9)',
            //           shadowBlur: 20
            //       }
            //   },
            //   data: []
            // },
            {
              name: 'ERP Avg Time',
              type: 'line',
              smooth: false,
              showAllSymbol: true,
              symbol: 'circle',
              symbolSize: 15,
              label: {
                show: true,
                position: 'top',
                textStyle: {
                  color: '#ff1010',
                }
              },
              itemStyle: {
                color: '#ff1010',
                borderColor: '#fff',
                borderWidth: 2,
                shadowColor: 'rgba(0, 0, 0, .3)',
                shadowBlur: 0,
                shadowOffsetY: 2,
                shadowOffsetX: 2,
              },
              areaStyle: {
                  normal: {
                      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                              offset: 0,
                              color: 'rgba(255,16,16,0.3)'
                          },
                          {
                              offset: 1,
                              color: 'rgba(255,16,16,0)'
                          }
                      ], false),
                      shadowColor: 'rgba(255,16,16, 0.9)',
                      shadowBlur: 20
                  }
              },
              data: []
            },
            {
              name: 'SAP Avg Time',
              type: 'line',
              smooth: false,
              showAllSymbol: true,
              symbol: 'circle',
              symbolSize: 15,
              label: {
                show: true,
                position: 'top',
                textStyle: {
                  color: '#6c50f3',
                }
              },
              itemStyle: {
                color: '#6c50f3',
                borderColor: '#fff',
                borderWidth: 3,
                shadowColor: 'rgba(0, 0, 0, .3)',
                shadowBlur: 0,
                shadowOffsetY: 2,
                shadowOffsetX: 2,
              },
              areaStyle: {
                  normal: {
                      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                              offset: 0,
                              color: 'rgba(108,80,243,0.3)'
                          },
                          {
                              offset: 1,
                              color: 'rgba(108,80,243,0)'
                          }
                      ], false),
                      shadowColor: 'rgba(108,80,243, 0.9)',
                      shadowBlur: 20
                  }
              },
              data: []
            },
            {
              name: 'WMS Avg Time',
              type: 'line',
              smooth: false,
              showAllSymbol: true,
              symbol: 'circle',
              symbolSize: 15,
              label: {
                show: true,
                position: 'top',
                textStyle: {
                  color: '#00ca95',
                }
              },
              itemStyle: {
                color: '#00ca95',
                borderColor: '#fff',
                borderWidth: 3,
                shadowColor: 'rgba(0, 0, 0, .3)',
                shadowBlur: 0,
                shadowOffsetY: 2,
                shadowOffsetX: 2,
              },
              areaStyle: {
                normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: 'rgba(0,202,149,0.3)'
                        },
                        {
                            offset: 1,
                            color: 'rgba(0,202,149,0)'
                        }
                    ], false),
                    shadowColor: 'rgba(0,202,149, 0.9)',
                    shadowBlur: 20
                }
              },
              data: []
            }
          ],
          xAxisData: [],
          tooltip: {
            trigger: 'axis',
            textStyle: { align: 'left' },
            axisPointer: {
              lineStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0,
                    color: 'rgba(0, 255, 233,0)'
                  }, {
                    offset: 0.5,
                    color: 'rgba(255, 255, 255,1)',
                  }, {
                    offset: 1,
                    color: 'rgba(0, 255, 233,0)'
                  }],
                  global: false
                }
              },
            },
          },
          yAxis: [{
            type: 'value',
            axisLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              margin: 20,
              textStyle: {
                color: 'black',
              },
            },
            axisTick: {
              show: false,
            },
          }]
        },
        queryParamsTime_pay: [],
        creationStartDate: moment(new Date() - 30 * 24 * 3600 * 1000).format('YYYY-MM-DD HH:mm:ss'),
        creationEndDate: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
      }
    };
  },
  watch: {
    'lineChart.queryParamsTime_pay': {
      immediate: false,
      handler(v) {
        if (v) {
          this.lineChart.creationStartDate = (v || [])[0];
          this.lineChart.creationEndDate = (v || [])[1];
          this.getOrderReport();
        } else {
          this.lineChart.creationStartDate = moment(new Date() - 30 * 24 * 3600 * 1000).format('YYYY-MM-DD HH:mm:ss');
          this.lineChart.creationEndDate = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
          this.getOrderReport();
        }
      }
    },
    'lineChart.tabData': {
      handler(v) {
        this.getOrderReport();
      }
    }
  },
  mounted() {
    this.getOrderReport();
  },
  methods: {
    // 根据年和周数转换为年月日
    getDateFromYearAndWeek(year, week) {
      const start = moment().year(year).isoWeek(week - 1).isoWeekday(1).format('YYYY-MM-DD');
      const end = moment().year(year).isoWeek(week).isoWeekday(0).format('YYYY-MM-DD');
      return `${start} to\n ${end}`;
    },

    // 清空 报表 操作
    emptyDataReport() {
      // this.lineChart.lineChartData.series[0].data = [];
      this.lineChart.lineChartData.series[0].data = [];
      this.lineChart.lineChartData.series[1].data = [];
      this.lineChart.lineChartData.series[2].data = [];
      this.lineChart.lineChartData.xAxisData = [];
    },
    // 获取报表
    getOrderReport() {
      const data = {
        creationStartDate: this.lineChart.creationStartDate,
        creationEndDate: this.lineChart.creationEndDate,
        reportType: this.lineChart.tabData
      };
      afterApi.getOrderReport(data).then(res => {
        if (!res.length) {
          this.emptyDataReport();
        } else {
          this.emptyDataReport();
          res.forEach(item => {
            item.orderCount = item.orderCount / 1000;
            // this.lineChart.lineChartData.series[0].data.push(item.orderCount);
            this.lineChart.lineChartData.series[0].data.push(item.erpAvgTime || 0);
            this.lineChart.lineChartData.series[1].data.push(item.sapAvgTime || 0);
            this.lineChart.lineChartData.series[2].data.push(item.wmsAvgTime || 0);
            if (this.lineChart.tabData === '1') {
              this.lineChart.lineChartData.xAxisData.push(this.getDateFromYearAndWeek(item.orderYear, item.orderDate));
            } else {
              this.lineChart.lineChartData.xAxisData.push(`${item.orderYear}-${item.orderDate}`);
            }
          });
        }
      });
    },
  },
};
</script>
